import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const preInfo = r => require.ensure([],() => r(require('@/views/preJob/index.vue')), 'preInfo')
const login = r => require.ensure([],() => r(require('@/views/user/login.vue')),'login')
const welcome = r => require.ensure([],() => r(require('@/views/welcome.vue')),'welcome')

const routes = [
  {
		path: '/',
		name: 'home',
		component: preInfo
	},{
		path: '/login',
		name: 'login',
		component: login
	},{
		path: '/welcome',
		name: 'welcome',
		component: welcome
	}
]
let router = new Router({
  routes
});
router.beforeEach((to, from, next) => {
  document.title = '入职采集系统'
  if(to.name==='home'&&to.query.key &&to.query.key!=undefined){
  	next()
  }else{
  	if( to.name != 'login' && (window.sessionStorage.token ===undefined || window.sessionStorage.getItem('token') ===null)){
   		next({
	      path: '/login'
	    })
	  }else{
	   next()
	  }
  }
  // ...
})
export default router




// WEBPACK FOOTER //
// ./src/router/index.js